import { slotsOf } from './node-spec.js';
/**
 * Step numbers («шаг 1…N») — one numbering shared by the canvas, the inspector,
 * «читать как текст» and the run history (spec §3.1).
 *
 * Breadth-first from `entryNodeId`; a node's children are visited in the fixed
 * slot order of {@link slotsOf} (Да before Нет, outcomes in schema order), so
 * branches number left to right the way they are drawn. Nodes unreachable from
 * the entry get numbers AFTER every reachable one, ordered by id — stable across
 * renders and independent of jsonb key order (which Postgres sorts by length,
 * the very reason the old editor listed `done` before `start`).
 *
 * Tolerates a broken graph mid-edit: dangling targets are skipped, cycles are
 * visited once, a missing entry makes every node «unreachable».
 */
export const numberSteps = (def) => {
    const order = reachableInOrder(def);
    const seen = new Set(order);
    const rest = Object.keys(def.nodes)
        .filter((id) => !seen.has(id))
        .sort(compareIds);
    const numberOf = {};
    [...order, ...rest].forEach((id, i) => {
        numberOf[id] = i + 1;
    });
    return numberOf;
};
/** Node ids reachable from the entry, in BFS / slot order (the numbering order). */
export const reachableInOrder = (def) => {
    if (!Object.prototype.hasOwnProperty.call(def.nodes, def.entryNodeId))
        return [];
    const order = [def.entryNodeId];
    const seen = new Set(order);
    for (let i = 0; i < order.length; i++) {
        const node = def.nodes[order[i]];
        if (!node)
            continue;
        for (const slot of slotsOf(node)) {
            const t = slot.target;
            if (t === null || seen.has(t) || !Object.prototype.hasOwnProperty.call(def.nodes, t))
                continue;
            seen.add(t);
            order.push(t);
        }
    }
    return order;
};
/** Code-unit order, not locale order: identical on every machine. */
export const compareIds = (a, b) => (a < b ? -1 : a > b ? 1 : 0);
//# sourceMappingURL=numbering.js.map